<div class="container">
  <fgbcl-lottos-list [isList]="true"></fgbcl-lottos-list>
</div>
